import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../Admin/Config/Config';
// import logo from './Mallu Bazzar Logo_F.png'; // Importing the logo image

export default function Terms() {
  const [aboutText, setAboutText] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const ref = doc(db, 'app_privacy_policy', 'privacy_policy');
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          setAboutText(data?.terms_and_conditions || '');
        }
      } catch (e) {
        console.error('Failed to load About content:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchAbout();
  }, []);

  return (

   
   


      <div className="max-w-7xl mx-auto  px-6 bg-white p-8 rounded-lg ">
          <h1 className="text-2xl text-left font-bold text-red-600 mb-4">About Us</h1>

         
        
       

    
        
       
          {loading ? (
            <p className="text-gray-500">Loading...</p>
          ) : aboutText && aboutText.trim().length > 0 ? (
            <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-line">
              {aboutText}
            </p>
          ) : null}
    </div>
  );
}
